<mat-toolbar class="mat-primary" *ngIf="!isMainLogin">
  <span fxFlex>Anmelden</span>
  <button
    class="icon-button"
    (click)="closeModal()"
    (keydown.enter)="closeModal()"
    (keydown.space)="closeModal()"
    aria-label="Modal schließen">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</mat-toolbar>
<mat-toolbar class="mat-primary" *ngIf="isMainLogin">
  <h4>Willkommen im Hausanschluss-Portal</h4>
</mat-toolbar>
<mat-toolbar class="mat-primary" *ngIf="isMainLogin">
  <img
    src="https://www.thuega-energienetze.de/typo3conf/ext/project_theme/Resources/Public/Images/logo.svg"
    height="50x"
    style="margin-bottom: 2rem" />
</mat-toolbar>

<mat-dialog-content>
  <form
    [formGroup]="formGroup"
    class="form"
    fxLayout="column"
    fxLayoutAlign=" none"
    fxLayoutGap="10px"
    *ngIf="!(hideLocalLogin$ | async) || window.location.href.includes('localhost')">
    <mat-form-field fxFlex="100" appearance="fill">
      <mat-label>E-Mail-Adresse</mat-label>
      <input matInput formControlName="username" />
      <mat-error *ngIf="!formGroup.controls['username'].valid && formGroup.controls['username'].touched">
        {{ validatorsService.getErrorMail(formGroup, 'username') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="100" appearance="fill">
      <mat-label>Passwort</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
      <mat-icon matSuffix (click)="hide = !hide">
        {{ hide ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">
        {{ validatorsService.getErrorPassword(formGroup, 'password') }}
      </mat-error>
    </mat-form-field>

    <mat-error *ngIf="error">E-Mail-Adresse oder Passwort ist falsch</mat-error>

    <!-- we want to hide forgot password if we use the external idp -->
    <span>
      <span class="clickable-text" (click)="forgotPassword()">Passwort vergessen</span>
    </span>

    <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
      <button mat-stroked-button (click)="closeModal()" color="primary" *ngIf="isMainLogin">Abbrechen</button>

      <button mat-raised-button color="primary" id="login" [disabled]="!formGroup.valid" (click)="logIn()">
        Anmelden
      </button>
    </div>

    <!-- TODO: this loading spinner is not visible :P -->
    <div class="spinner-container" *ngIf="isLoading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </form>

  <div
    *ngIf="showExternalIdpLogin$ | async"
    class="azure-login-container"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="10px">
    <div class="separator">
      <span>oder</span>
    </div>
    <button mat-raised-button color="accent" (click)="loginWithExternalIDP()">
      <mat-icon>account_circle</mat-icon>
      {{ externalIdpButtonText$ | async }}
    </button>
    <span>{{ externalIdpDescription$ | async }}</span>
  </div>
</mat-dialog-content>
